/**
 * Dependency-free SVG sparkline. Renders a smooth 7-point line with a soft
 * fill underneath, a dot on today's value, and zero overhead (no chart lib).
 */
export default function Sparkline({
  values = [],
  width = 80,
  height = 28,
  strokeWidth = 1.5,
  color = "currentColor",
}) {
  if (!values || values.length === 0) {
    return <div style={{ width, height }} aria-hidden="true" />;
  }
  const n = values.length;
  const max = Math.max(...values, 1);
  const min = Math.min(...values, 0);
  // Leave 10% padding inside the SVG so strokes don't clip
  const padY = 2;
  const range = Math.max(max - min, 1);
  const stepX = (width - 2) / (n - 1 || 1);
  const points = values.map((v, i) => {
    const x = 1 + i * stepX;
    const y = padY + (height - padY * 2) * (1 - (v - min) / range);
    return [x, y];
  });
  const pathD = points
    .map((p, i) => (i === 0 ? `M${p[0]},${p[1]}` : `L${p[0]},${p[1]}`))
    .join(" ");
  const areaD = `${pathD} L${points[n - 1][0]},${height} L${points[0][0]},${height} Z`;
  const last = points[n - 1];
  const uid = `spk-${Math.random().toString(36).slice(2, 9)}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden="true"
      style={{ display: "block", color }}
    >
      <defs>
        <linearGradient id={uid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="currentColor" stopOpacity="0.28" />
          <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={areaD} fill={`url(#${uid})`} />
      <path
        d={pathD}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <circle cx={last[0]} cy={last[1]} r={2.5} fill="currentColor" />
    </svg>
  );
}
